import authRequest from "@/api/http/authRequest";

export default {
  searchFiles(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/files`, params, cb, errCb)
  },
  updateFile(params: any, cb: (response) => void, errCb: (response) => void) {
    const formData = new FormData()
    formData.append('memo', params.memo || "")
    formData.append('name', params.name)
    formData.append('status', params.status)
    formData.append('popupContent', params.popupContent)
    formData.append('passUnlock', params.passUnlock || false)
    if (params.lessonContentId) {
      formData.append('lessonContentId', params.lessonContentId)
    }
    if (params.file) {
      formData.append('file', params.file)
      if (params.filePath) {
        formData.append('filePath', params.filePath)
      }
    }

    authRequest.postWithFile(`/admin/file/${params.id}`, formData, cb, errCb)
  },
  deleteFile(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.delete(`/admin/file/${params.id}`, cb, errCb)
  },
  uploadFile (params: any, cb: (response) => void, errCb: (response) => void) {
    const formData = new FormData()
    formData.append('file', params.file)
    formData.append('filePath', params.filePath)
    formData.append('memo', params.memo || "")
    formData.append('name', params.name)
    formData.append('status', params.status)
    formData.append('popupContent', params.popupContent)
    formData.append('passUnlock', params.passUnlock || false)
    if (params.lessonContentId) {
      formData.append('lessonContentId', params.lessonContentId)
    }
    authRequest.postWithFile(`/admin/file`, formData, cb, errCb)
  }
}
